import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Filter } from '../models/filter.model';

@Injectable({
    providedIn: 'root'
})
export class ReportsService {

    constructor(private httpClient: HttpClient) { }

    offerReport(filter: Filter) {
        return this.httpClient.post('api/reports/offers', { Filter: filter.data.Filter })
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }


    offerExcelReport(filter: Filter) {
        return this.httpClient.post('api/reports/offers/excel', { Filter: filter.data.Filter }, { observe: 'response', responseType: 'blob' })
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }


    appointmentReport(filter: Filter) {
        return this.httpClient.post('api/reports/appointments', { Filter: filter.data.Filter })
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    appointmentExcelReport(filter: Filter) {
        return this.httpClient.post('api/reports/appointments/excel', { Filter: filter.data.Filter }, { observe: 'response', responseType: 'blob' })
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    CCReport(filter: Filter, reportType: Number, groupBy: String) {
        return this.httpClient.post('api/reports/cc', { Filter: filter.data.Filter, ReportType: reportType, GroupBy: groupBy })
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    CCExcelReport(filter: Filter, reportType: Number, groupBy: String) {
        return this.httpClient.post('api/reports/cc/excel', { Filter: filter.data.Filter, ReportType: reportType, GroupBy: groupBy }, { observe: 'response', responseType: 'blob' })
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

}